<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.134 6.13867C60.134 7.9336 58.6744 9.38867 56.8738 9.38867C55.0732 9.38867 53.6136 7.9336 53.6136 6.13867C53.6136 4.34375 55.0732 2.88867 56.8738 2.88867C58.6744 2.88867 60.134 4.34375 60.134 6.13867ZM59.0473 26.3609C59.0473 38.7259 48.992 48.7498 36.5881 48.7498C24.1842 48.7498 14.1289 38.7259 14.1289 26.3609C14.1289 13.9959 24.1842 3.97201 36.5881 3.97201C48.992 3.97201 59.0473 13.9959 59.0473 26.3609ZM63.5753 12.6387C64.4756 12.6387 65.2054 11.9111 65.2054 11.0137C65.2054 10.1162 64.4756 9.38867 63.5753 9.38867C62.6751 9.38867 61.9452 10.1162 61.9452 11.0137C61.9452 11.9111 62.6751 12.6387 63.5753 12.6387Z"
      fill="url(#paint0_radial_410_32633)"
    />
    <path
      d="M21.3711 28.4292C21.3711 26.8287 22.6686 25.5312 24.2691 25.5312H32.6007C34.2012 25.5312 35.4986 26.8287 35.4986 28.4292L35.4986 34.6651C35.4986 35.0652 35.1743 35.3896 34.7742 35.3896H22.0956C21.6955 35.3896 21.3711 35.0652 21.3711 34.6651L21.3711 28.4292Z"
      fill="url(#paint1_radial_410_32633)"
    />
    <path
      d="M23.9922 19.1928C23.9922 16.4705 26.2145 14.2637 28.9368 14.2637C31.6591 14.2637 33.8815 16.4705 33.8815 19.1928C33.8815 21.9151 31.6591 24.122 28.9368 24.122C26.2145 24.122 23.9922 21.9151 23.9922 19.1928Z"
      fill="url(#paint2_radial_410_32633)"
    />
    <path
      d="M37.6719 28.4292C37.6719 26.8287 38.9693 25.5312 40.5698 25.5312H48.9015C50.502 25.5312 51.7994 26.8287 51.7994 28.4292L51.7994 34.6651C51.7994 35.0652 51.4751 35.3896 51.0749 35.3896H38.3964C37.9962 35.3896 37.6719 35.0652 37.6719 34.6651L37.6719 28.4292Z"
      fill="url(#paint3_radial_410_32633)"
    />
    <path
      d="M40.293 19.1928C40.293 16.4705 42.5153 14.2637 45.2376 14.2637C47.9599 14.2637 50.1823 16.4705 50.1823 19.1928C50.1823 21.9151 47.9599 24.122 45.2376 24.122C42.5153 24.122 40.293 21.9151 40.293 19.1928Z"
      fill="url(#paint4_radial_410_32633)"
    />
    <path
      d="M26.8047 27.1655C26.8047 25.565 28.1021 24.2676 29.7026 24.2676H43.468C45.0685 24.2676 46.3659 25.565 46.3659 27.1655L46.3659 37.1931C46.3659 37.5932 46.0415 37.9176 45.6414 37.9176H27.5292C27.1291 37.9176 26.8047 37.5932 26.8047 37.1931L26.8047 27.1655Z"
      fill="url(#paint5_radial_410_32633)"
    />
    <path
      d="M30.2422 15.491C30.2422 11.7217 33.3193 8.66602 37.0886 8.66602C40.858 8.66602 43.935 11.7217 43.935 15.491C43.935 19.2604 40.858 22.316 37.0886 22.316C33.3193 22.316 30.2422 19.2604 30.2422 15.491Z"
      fill="url(#paint6_radial_410_32633)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(56.5116 -9.20855) rotate(115.508) scale(69.8193 69.9573)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.7862 38.9744) rotate(-118.555) scale(17.9124 34.6528)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.6828 27.7069) rotate(-110.854) scale(16.8364 25.8071)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50.087 38.9744) rotate(-118.555) scale(17.9124 34.6528)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.9836 27.7069) rotate(-110.854) scale(16.8364 25.8071)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.0305 43.7227) rotate(-120.392) scale(22.5546 35.4724)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32633"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.8002 28.1212) rotate(-112.321) scale(21.031 26.6295)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
